import { render, staticRenderFns } from "./AddClientAttendanceModal.vue?vue&type=template&id=4ce68f58&scoped=true"
import script from "./AddClientAttendanceModal.vue?vue&type=script&lang=js"
export * from "./AddClientAttendanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce68f58",
  null
  
)

export default component.exports